export const ALLOWED_LANGS = ["cs", "de", "en", "hu", "pl", "ro", "sk"]
